<template>
  <div class="col-12 form-group form-group-sm">
    <label class="label" for="vehiculo">Vehículo</label>
    <div class="card">
      <div class="card-body">
        <template v-if="!vehiculo">
          <div class="d-flex justify-content-around">
            <button
              class="btn btn-primary"
              type="button"
              @click="crearVehiculo"
            >
              Crear Vehículo
            </button>
          </div>
        </template>
        <template v-if="vehiculo">
          <div class="container position-relative">
            <div class="row">
              <div class="col-12 col-md-6 form-group form-group-sm">
                <label class="label" for="marca">Patente - Alias</label>
                <input
                  id="marca"
                  :class="`form-control form-control-sm text-center bg-white`"
                  :value="`${vehiculo.patente} - ${vehiculo.dominio}`"
                  disabled
                  style="cursor: text"
                  type="text"
                />
              </div>
              <div class="col-12 col-md-6 form-group form-group-sm">
                <label class="label" for="marca">Marca y modelo</label>
                <input
                  id="marca"
                  :class="`form-control form-control-sm text-center bg-white`"
                  :value="`${vehiculo.marca} - ${vehiculo.modelo}`"
                  disabled
                  style="cursor: text"
                  type="text"
                />
              </div>
            </div>
            <div style="position: absolute; top: -10px; right: 0">
              <button
                class="btn btn-sm btn-warning"
                type="button"
                @click="cambiarVehiculo"
              >
                Quitar
              </button>
            </div>
          </div>
        </template>
      </div>
    </div>
    <CrearVehiculo v-model="vehiculo" />
  </div>
</template>

<script>
import CrearVehiculo from "@/pages/Clientes/Contratos/Commons/SelectVehiculo/CrearVehiculo";

export default {
  name: "SelectVehiculo",
  components: { CrearVehiculo },
  props: ["value"],
  computed: {
    vehiculo: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    crearVehiculo() {
      this.$bvModal.show("crearVehiculoModal");
    },
    cambiarVehiculo() {
      this.vehiculo = null;
    },
  },
};
</script>

<style scoped></style>
